module.exports = __webpack_public_path__ + "static/img/CgoRDGOSoYiAYlMWAAlRcFAEnvs423.366253c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGOSoYiAYlMWAAlRcFAEnvs423.png
// module id = +2PV
// module chunks = 73